import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import QUERY_KEYS from '../query/queryKeys';
import { fetchUserProjectAccess } from '../modules/users';

export const useRole = () => {
  const [role, setRole] = useState();
  useEffect(() => {
    const storedRole = JSON.parse(localStorage.getItem('role'));
    setRole(storedRole);
  }, []);

  return role;
};

export const useUserAccess = () => {
  const {
    data: userAccess,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: QUERY_KEYS.users.projectAccess(),
    queryFn: fetchUserProjectAccess,
  });

  const {
    is_full_access: isFullAccess = false,
    is_executive_manager: isExecutiveManager = false,
    is_project_admin: isProjectAdmin = false,
    project_ids: projectIds = [],
  } = userAccess || {};

  const canSeeAllDefects =
    isFullAccess || isExecutiveManager || isProjectAdmin;

  return {
    isFullAccess,
    isExecutiveManager,
    isProjectAdmin,
    projectIds,
    canSeeAllDefects,
    error,
    isError,
    isLoading,
  };
};
